function CircleCheck({ fill = "#2E5BFF", size = 59 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 59 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.5 0C13.233 0 0 13.233 0 29.5C0 45.767 13.233 59 29.5 59C45.767 59 59 45.767 59 29.5C59 13.233 45.767 0 29.5 0ZM44.4517 23.2485L28.4723 39.2274C27.993 39.7068 27.3637 39.9481 26.7344 39.9481C26.1051 39.9481 25.4758 39.7068 24.9964 39.2274L17.007 31.238C16.0455 30.2769 16.0455 28.7231 17.007 27.762C17.968 26.8005 19.5214 26.8005 20.4829 27.762L26.7344 34.0135L40.9757 19.7726C41.9368 18.8111 43.4902 18.8111 44.4517 19.7726C45.4127 20.7336 45.4127 22.287 44.4517 23.2485Z"
        fill={fill}
      />
    </svg>
  );
}

export default CircleCheck;
